import { IoIosArrowForward } from "react-icons/io";
import { Link } from "react-router-dom";
import './Explore.scss';
import { ExploreItem, ExploreItemType } from "./explore/components/ExploreItem";
import { useExploreData } from "./useExploreData";
import { ModelListDashboardItem, PoProject } from "../api/__gen__/data-contracts";
import LoadingIndicator from "../components/LoadingIndicator";



const ExploreSection = ({
  title,
  sectionItems,
  type
}: {
  title: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sectionItems: ModelListDashboardItem[] | PoProject[],
  type: ExploreItemType

}) => {
  return <div className="mb-12">
    {/* title and view more */}
    <div className="flex justify-between mb-6">
      <div>
        <h2 className="text-3xl font-bold">{title}</h2>
      </div>
      <div className="flex items-center cursor-pointer">
        <Link to={`/v2/explore/${type}`}>More</Link> <IoIosArrowForward />
      </div>
    </div>

    <div id="section-content" className=" flex justify-between flex-wrap">
      {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (sectionItems).map((item, index: number) => {
          return <ExploreItem
            title={item?.name || item?.displayName}
            author={item?.owner?.name || item?.creator?.name}
            imgUrl={item?.image}
            description={item?.detail || item?.description}
            item={item}
            key={index} type={type || ExploreItemType.API} />
        })
      }
    </div>

  </div>
}

const Explore = () => {
  const {
    publicApis,
    publicTables,
    publicDashboards,
    isLoading
  } = useExploreData()

  return (
    <div>
      {/* <div className="banner py-24 bglogo">
        <h1 className="text-5xl font-semibold text-center mb-6">
          Welcome to ZettaBlock Explore
        </h1>
        <h3 className="mb-12 text-center text-violet-400 font-medium leading-tight">Explore APIs, Tables and Query created by the best builders in Web3.</h3>
        <SearchBar />
      </div> */}
      <div className="flex justify-center mt-16">
        <div className="max-w-[1080px] 2xl:max-w-[1600px] px-6">
          {
            isLoading ? <div className="flex justify-center items-center">
              <LoadingIndicator />
            </div> : <>
              <ExploreSection
                sectionItems={publicApis}
                title="APIs"
                type={ExploreItemType.API}
              />
              <ExploreSection
                sectionItems={publicTables}
                title="Tables"
                type={ExploreItemType.TABLE}
              />
              <ExploreSection
                sectionItems={publicDashboards.slice(0, 12)}
                title="Dashboards"
                type={ExploreItemType.DASHBOARD}
              />
            </>
          }
        </div>
      </div>
    </div>
  )
}

export default Explore;